var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.000183105C15.514 0.000183105 20 4.48618 20 10.0002C20 15.5142 15.514 20.0002 10 20.0002C4.48599 20.0002 0 15.5142 0 10.0002C0 4.48614 4.48599 0.000183105 10 0.000183105ZM10 18.7502C14.8247 18.7502 18.75 14.8249 18.75 10.0002C18.75 5.17544 14.8247 1.25019 10 1.25019C5.17525 1.25019 1.25001 5.1754 1.25001 10.0002C1.25001 14.8249 5.17525 18.7502 10 18.7502ZM4.4531 10.0002C4.4531 10.3454 4.73295 10.6252 5.07811 10.6252H9.375V14.9221C9.375 15.2673 9.65484 15.5471 10 15.5471C10.3452 15.5471 10.625 15.2673 10.625 14.9221V10.6252H14.9219C15.2671 10.6252 15.5469 10.3454 15.5469 10.0002C15.5469 9.65499 15.2671 9.37518 14.9219 9.37518H10.625V5.07829C10.625 4.73309 10.3452 4.45329 10 4.45329C9.65484 4.45329 9.375 4.73309 9.375 5.07829V9.37518H5.07811C4.73295 9.37518 4.4531 9.65503 4.4531 10.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.f421cb6bde4ae1c6b9eb4ac3304c8954.svg";
export { ForwardRef as ReactComponent };